module.exports = __webpack_public_path__ + "img/dcu30-char-5.872b607a.png";